/* GP delivery destination: Shopify-native localization POST; no imitation shipping rate calculations */
(function(){
  'use strict';
  const init=()=>{
    const overlay=document.querySelector('[data-gp-delivery-modal]');
    if(!overlay)return;
    const dialog=overlay.querySelector('.gp-delivery-dialog');
    const select=overlay.querySelector('[data-gp-delivery-country]');
    const form=overlay.querySelector('form');
    const confirm=overlay.querySelector('[data-gp-delivery-confirm]');
    const opener=[...document.querySelectorAll('[data-gp-delivery-open]')];
    if(!select?.options?.length||!form)return;
    let lastFocus=null;
    const key='gp_delivery_destination_confirmed_v1';
    const activeCode=select.value;
    let confirmed='';
    try{confirmed=localStorage.getItem(key)||''}catch(e){}
    let firstOpen=true;
    const open=()=>{
      lastFocus=document.activeElement;
      overlay.hidden=false;overlay.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
      select.focus();
    };
    const close=()=>{
      overlay.hidden=true;overlay.setAttribute('aria-hidden','true');
      document.body.style.overflow='';
      if(firstOpen){firstOpen=false;try{sessionStorage.setItem('gp_delivery_modal_dismissed_v1','1')}catch(e){}}
      lastFocus?.focus?.();
    };
    opener.forEach(el=>el.addEventListener('click',open));
    overlay.querySelectorAll('[data-gp-delivery-close]').forEach(el=>el.addEventListener('click',close));
    overlay.addEventListener('mousedown',e=>{if(e.target===overlay)close()});
    document.addEventListener('keydown',e=>{
      if(overlay.hidden)return;
      if(e.key==='Escape'){e.preventDefault();close();return}
      if(e.key==='Tab'){
       const possible=[...dialog.querySelectorAll('button:not([disabled]),select:not([disabled])')].filter(el=>el.offsetParent!==null);
       if(!possible.length)return;
       const first=possible[0],last=possible[possible.length-1];
       if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
       else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
      }
    });
    form.addEventListener('submit',e=>{
      const country=select.value;
      if(!country||!Array.from(select.options).some(o=>o.value===country)){e.preventDefault();return}
      try{localStorage.setItem(key,country)}catch(err){}
      const currencyByCountry={BH:'BHD',SA:'SAR',AE:'AED',KW:'KWD',QA:'QAR',OM:'OMR'};
      const currency=currencyByCountry[country];
      if(currency){try{sessionStorage.setItem('gp_currency_requested',currency)}catch(err){}}

      if(country===activeCode){e.preventDefault();close();return}
      if(confirm){confirm.disabled=true;confirm.textContent='Updating destination...'}
    });
    let dismissed=false;try{dismissed=sessionStorage.getItem('gp_delivery_modal_dismissed_v1')==='1'}catch(err){}
    if(!dismissed&&confirmed!==activeCode){
      /* Open once after a short paint delay. Returning shoppers with a saved selection are not interrupted. */
      requestAnimationFrame(()=>{if(!overlay.hidden)return;open()});
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();